import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DriversMap from './pages/DriversMap';
import VerificationQueue from './pages/VerificationQueue';
import DriverProfile from './pages/DriverProfile';
import Zones from './pages/Zones';
import Promotions from './pages/Promotions';
import SupportTickets from './pages/SupportTickets';
import PayoutRequests from './pages/PayoutRequests';
import RevenueModeRequests from './pages/RevenueModeRequests';
import AuditLogs from './pages/AuditLogs';
import PricingConfig from './pages/PricingConfig';
import Users from './pages/Users';
import Emergencies from './pages/Emergencies';
import Rides from './pages/Rides';

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        {/* Secure Dashboard Routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="map" element={<DriversMap />} />
          <Route path="validation" element={<VerificationQueue />} />
          <Route path="drivers" element={<DriverProfile />} />
          <Route path="users" element={<Users />} />
          <Route path="zones" element={<Zones />} />
          <Route path="promotions" element={<Promotions />} />
          <Route path="support" element={<SupportTickets />} />
          <Route path="payout-requests" element={<PayoutRequests />} />
          <Route path="revenue-requests" element={<RevenueModeRequests />} />
          <Route path="pricing-config" element={<PricingConfig />} />
          <Route path="audit-logs" element={<AuditLogs />} />
          <Route path="emergencies" element={<Emergencies />} />
          <Route path="rides" element={<Rides />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
